import { preloadIntentBasedOnboardingState } from '@confluence/onboarding-helpers/entry-points/preloadIntentBasedOnboardingState';
import { preloadGetLicensedProductsQuery } from '@confluence/onboarding-helpers/entry-points/preloadGetLicensedProductsQuery';
import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError';

export const INTENT_BASED_ONBOARDING_QUERY = 'IntentBasedOnboardingQuery';

export const preloadIntentBasedOnboarding = () => {
	return waitForAllReturnWhenError([
		preloadIntentBasedOnboardingState(),
		preloadGetLicensedProductsQuery(),
	]);
};
